define('controllers/hotelispr',['require','johngrid'],function (require) {
    var CreateJohnGrid = require('johngrid');
    return function() {
        var tblISPRReports = $("#tblISPRReports"),
               grid = CreateJohnGrid(),
               columns = [{ DataField: "FileName" }, { DataField: "CreateDate" }];

        grid.sorting.allowSorting = true;
        grid.dsPostValues.sortClause = "CreateDate DESC";
        grid.init(tblISPRReports, columns, "ISPRAJAX.aspx");
        grid.databind();
    };
});

